/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      component — progress bar segments for the multi-step booking form
 *   extends:   Component (@glimmer/component)
 *   template:  form-progress.hbs
 *   args:      @steps, @currentStep, @totalSteps
 *   uses:      -
 *   siblings:  form-step-dati.js, form-step-modulo.js, form-step-project.js
 *   tests:     form-components-test.js, template-components-test.js
 *
 * Pure-getter component: maps @steps into per-segment done/active flags
 * relative to @currentStep for the booking form's progress indicator.
 * @currentStep is a 0-based index; stepNumber is the 1-based number read by
 * screen readers (aria-valuenow, sr-only «Step n of N»), same as the visible counter.
 */
import Component from '@glimmer/component';

export default class FormProgressComponent extends Component {
  get segments() {
    const steps = this.args.steps ?? [];
    const current = this.args.currentStep ?? 0;
    return steps.map((name, i) => ({
      name,
      done: i < current,
      active: i === current,
    }));
  }

  get stepNumber() {
    return (Number(this.args.currentStep) || 0) + 1;
  }
}
